import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService } from '../../services/dialog-service/dialog-service.service';
import { OrganisationService } from '../../services/dataServices/organisation-service/organisationservice';
import { UserService } from '../../services/user-service/userservice';

@Component({
    selector: 'app-analytics',
    templateUrl: './analytics.component.html',
    styleUrls: ['./analytics.component.css'],
    standalone: false
})
export class AnalyticsComponent implements OnInit {

  private trackingUrl?;
  sanitizedTrackingUrl: SafeResourceUrl;

  constructor(
    public organisationService: OrganisationService,
    private userService: UserService,
    private router: Router,
    private titleService: Title,
    private sanitizer: DomSanitizer
  ) {
    document.documentElement.style.setProperty('--scrollStatus', 'auto');
    if (
      !this.userService.currentMemberships.find(
        (orga) =>
          orga.organisationId ===
          this.organisationService.activeItem.organisationId
      )
    ) {
      this.router.navigateByUrl('/marktplatz');
    }
    else {

    }
  }

  ngOnInit(): void {
    this.titleService.setTitle(
      'Mitglieder verwalten: ' +
      this.organisationService.activeItem.organisationName +
      ' - BIMSWARM'
    );
    this.updateIframeUrl();
    // window.location.href = "http://bimswarm.online:4018/b/Artaker_CAD_Systems_3";
  }

  ngOnDestroy() {
    document.documentElement.style.setProperty('--scrollStatus', 'hidden');
  }

  updateIframeUrl() {
    this.trackingUrl = "https://chartbrew.bimswarm.online/b/Artaker_CAD_Systems_3" + "?theme=light";
    this.sanitizedTrackingUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.trackingUrl);
  }
}
